import React, { useEffect, useState } from "react";

const BackgroundImages = () => {
  const [pageHeight, setPageHeight] = useState(0);
  const imageHeight = 500;
  const topOffset = 200;

  useEffect(() => {
    const updateHeight = () => setPageHeight(document.body.scrollHeight);

    // Delay the initial height update to ensure all products load first
    const initialLoadDelay = setTimeout(updateHeight, 700);

    // Listen for window resize
    window.addEventListener("resize", updateHeight);

    // Use MutationObserver to detect content changes (e.g., product loading)
    const observer = new MutationObserver(() => updateHeight());
    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup
    return () => {
      clearTimeout(initialLoadDelay);
      window.removeEventListener("resize", updateHeight);
      observer.disconnect();
    };
  }, []);

  // Calculate how many times the image should repeat down the page, minus 1
  const numRepeats = Math.max(0, Math.ceil((pageHeight - topOffset) / imageHeight) - 1);

  return (
    <div className="bg-images-container" style={{ height: `${pageHeight}px` }}>
      <div className="bg-images-wrapper left" style={{ top: `${topOffset}px` }}>
        {[...Array(numRepeats)].map((_, index) => (
          <img key={index} src="/././Assets/ChoopoStickman.png" alt="Choopo Logos Left" className="bg-image" />
        ))}
      </div>
      <div className="bg-images-wrapper right" style={{ top: `${topOffset}px` }}>
        {[...Array(numRepeats)].map((_, index) => (
          <img key={index} src="/././Assets/ChoopoStickman.png" alt="Choopo Logos Right" className="bg-image" />
        ))}
      </div>
    </div>
  );
};

export default BackgroundImages;
